import { OrganizationSubjects } from '../enums/OrganizationSubjects'

export default {
  computed: {
    isGkoOrganizationSubject () {
      return this.form.organization.subject_id === OrganizationSubjects.Gko
    }
  }
}
